import React from 'react'
import { Flag } from 'components/generic/Country'
import i18n from 'constants/strings'
import { Player } from 'types/global'
import styles from '../styles/profile-styles.module.scss'
import classNames from 'classnames'

const OptedOutPlayer = ({ player, bold = false }: { player: Player; bold?: boolean }) => {
  return (
    <span
      className={classNames(styles.matchResultText, {
        [styles.matchResultTextWon]: bold,
      })}
    >
      <Flag alpha3={player.countryCode} />

      {i18n.t('strData.optOutPlayerName')}

      <span className={styles.matchResultsRating}>{` (${
        player.contemporaryWtn || i18n.t('strData.na')
      })`}</span>
    </span>
  )
}

export default OptedOutPlayer
